export const OrderStatusEnum
  = {
  OPEN: "Open",
  FILLED: "Filled",
  IN_REVIEW: "In review",
  READY_FOR_PAYMENT: "Ready for payment",
  CHANGES_REQUIRED: "Changes required",
  DONE: "Done"
}